import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Standings from './components/Standings';
import MakePicks from './components/MakePicks';
import AdminGames from './components/AdminGames';
import './App.css';

function Navigation() {
  const location = useLocation();
  
  return (
    <nav className="navbar">
      <div className="navbar-content">
        <h1>McPickSix</h1>
        <nav>
          <Link 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
          >
            Standings
          </Link>
          <Link 
            to="/picks" 
            className={location.pathname === '/picks' ? 'active' : ''}
          >
            Make Picks
          </Link>
          <Link 
            to="/admin" 
            className={location.pathname === '/admin' ? 'active' : ''}
          >
            Admin
          </Link>
        </nav>
      </div>
    </nav>
  );
}

function App() {
  return (
    <div className="app">
      <Router>
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Standings />} />
            <Route path="/picks" element={<MakePicks />} />
            <Route path="/admin" element={<AdminGames />} />
          </Routes>
        </main>
      </Router>
    </div>
  );
}

export default App;

